(function () {
  'use strict';
  var atelierOrigin = 'https://portrait-animaux.compagnonsdecoeur.fr';
  var frame = document.querySelector('#atelier-portrait-animal iframe');
  if (!frame) return;
  var uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var pending = new Set();
  var queue = Promise.resolve();
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var cartUrl = root.replace(/\/$/, '') + '/cart';
  var operationPrefix = 'cdc-textile-cart-op-v2:';
  var syncing = false;
  function pause(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

  function send(payload) { frame.contentWindow.postMessage(payload, atelierOrigin); }
  var privacyReady = false;
  function sendAnalyticsConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = false;
    if (privacyReady && privacy && typeof privacy.currentVisitorConsent === 'function' && typeof privacy.analyticsProcessingAllowed === 'function') {
      var choice = privacy.currentVisitorConsent();
      allowed = choice && choice.analytics === 'yes' && privacy.analyticsProcessingAllowed() === true;
    }
    // Shopify may finish loading privacy before the iframe navigates away from
    // about:blank. The iframe load and ready messages retry after navigation.
    try { send({ type: 'cdc-textile-analytics-consent', version: 1, allowed: Boolean(allowed) }); }
    catch (error) {
      if (!error || (error.name !== 'SecurityError' && error.name !== 'SyntaxError')) throw error;
    }
  }
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      privacyReady = !error;
      sendAnalyticsConsent();
    });
  }
  document.addEventListener('visitorConsentCollected', sendAnalyticsConsent);
  frame.addEventListener('load', sendAnalyticsConsent);
  async function cart() {
    var response = await fetch(cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Le panier Shopify est indisponible.');
    return response.json();
  }
  function quantityFor(data, id) {
    return data.items.filter(function (item) { return item.properties && item.properties._cdc_creation_id === id; })
      .reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }
  function publishedState(data) {
    return { type: 'cdc-textile-cart-state', version: 1, cartItemCount: data.item_count,
      creations: data.items.filter(function (item) { return item.properties && uuid.test(item.properties._cdc_creation_id || ''); })
        .map(function (item) { return { id: item.properties._cdc_creation_id, quantity: item.quantity }; }) };
  }
  async function refreshShella(data) {
    if (window.theme && window.theme.Cart) {
      window.theme.Cart.setCurrentData(data);
      await window.theme.Cart.updateCart();
    }
  }
  async function sync() {
    if (syncing) return;
    syncing = true;
    try { var current = await cart(); send(publishedState(current)); await refreshShella(current); }
    catch (error) { console.warn('[cdc-textile-cart] Synchronisation différée', error); }
    finally { syncing = false; }
  }
  async function handleAdd(message) {
    var result = { type: 'cdc-textile-cart-result', version: 1, requestId: message.requestId, status: 'pending_verification' };
    try {
      var prior = sessionStorage.getItem(operationPrefix + message.requestId);
      if (prior) {
        var saved = JSON.parse(prior);
        if (saved.creationId !== message.creationId) throw new Error('Identifiant de reprise incohérent.');
        var already = await cart();
        if (quantityFor(already, message.creationId) >= saved.expectedQuantity) {
          result.status = 'added'; result.cartItemCount = already.item_count;
          result.creation = { id: message.creationId, quantity: quantityFor(already, message.creationId) };
          send(result); await sync(); return;
        }
        if (saved.status === 'not_added') { result.status = 'not_added'; send(result); return; }
        if ((saved.status === 'ambiguous' || saved.status === 'accepted') && Date.now() - saved.startedAt >= 5000 && quantityFor(already, message.creationId) === saved.beforeQuantity) {
          await pause(150);
          var confirmed = await cart();
          if (quantityFor(confirmed, message.creationId) === saved.beforeQuantity) {
            saved.status = 'not_added';
            sessionStorage.setItem(operationPrefix + message.requestId, JSON.stringify(saved));
            result.status = 'not_added'; result.cartItemCount = confirmed.item_count;
            send(result); send(publishedState(confirmed)); return;
          }
        }
        send(result); return;
      }
      var resolvedResponse = await fetch(atelierOrigin + '/api/textile-cart/resolve', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(message), cache: 'no-store'
      });
      var resolved = await resolvedResponse.json();
      if (!resolvedResponse.ok || resolved.requestId !== message.requestId || resolved.creationId !== message.creationId || resolved.quantity !== 1 || !Number.isSafeInteger(resolved.variantId)) {
        throw new Error(resolved.error || 'Création non autorisée.');
      }
      var before = await cart();
      var expectedQuantity = quantityFor(before, message.creationId) + 1;
      sessionStorage.setItem(operationPrefix + message.requestId, JSON.stringify({ creationId: message.creationId,
        beforeQuantity: expectedQuantity - 1, expectedQuantity: expectedQuantity, startedAt: Date.now() }));
      var response;
      try {
        response = await fetch(cartUrl + '/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: resolved.variantId, quantity: 1, properties: resolved.properties }] })
        });
      } catch { response = null; }
      if (!response || response.ok) {
        var operation = JSON.parse(sessionStorage.getItem(operationPrefix + message.requestId));
        operation.status = response ? 'accepted' : 'ambiguous';
        sessionStorage.setItem(operationPrefix + message.requestId, JSON.stringify(operation));
      }
      if (response && !response.ok) {
        var failure = await response.json().catch(function () { return {}; });
        result.status = 'rejected'; result.error = failure.description || 'Shopify a refusé cet ajout.';
        sessionStorage.removeItem(operationPrefix + message.requestId);
        send(result); return;
      }
      var after = await cart();
      var matching = after.items.filter(function (item) {
        return item.variant_id === resolved.variantId && item.properties &&
          item.properties._cdc_creation_id === message.creationId &&
          item.properties._cdc_signature === resolved.properties._cdc_signature;
      });
      var quantity = matching.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (quantity < expectedQuantity) { send(result); return; }
      result.status = 'added'; result.cartItemCount = after.item_count;
      result.creation = { id: message.creationId, quantity: quantity };
      send(result);
      try { await refreshShella(after); if (window.theme && window.theme.Cart) window.theme.Cart.showPopup(); }
      catch (error) { console.warn('[cdc-textile-cart] Panier ajouté, affichage différé', error); }
      send(publishedState(after));
    } catch (error) {
      result.status = sessionStorage.getItem(operationPrefix + message.requestId) ? 'pending_verification' : 'rejected';
      result.error = error && error.message || 'Ajout non confirmé.';
      send(result);
    }
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== atelierOrigin || event.source !== frame.contentWindow) return;
    var data = event.data;
    if (!data || typeof data !== 'object' || data.version !== 1) return;
    if (data.type === 'cdc-textile-consent-ready') { sendAnalyticsConsent(); return; }
    if (data.type === 'cdc-textile-cart-ready') { void sync(); return; }
    if (data.type === 'cdc-textile-cart-checkout' && uuid.test(data.creationId || '')) {
      void cart().then(function (current) {
        if (quantityFor(current, data.creationId) > 0) window.location.assign('/checkout');
        else send({ type: 'cdc-textile-cart-checkout-error', version: 1, creationId: data.creationId,
          error: 'La création n’est plus dans le panier Shopify.' });
      }).catch(function () {
        send({ type: 'cdc-textile-cart-checkout-error', version: 1, creationId: data.creationId,
          error: 'Le panier Shopify ne peut pas être vérifié.' });
      });
      return;
    }
    if (data.type !== 'cdc-textile-cart-add' || !uuid.test(data.requestId || '') || !uuid.test(data.creationId || '') || data.quantity !== 1) return;
    if (pending.has(data.requestId)) return;
    pending.add(data.requestId);
    queue = queue.then(function () { return handleAdd(data); }).finally(function () { pending.delete(data.requestId); });
  });

  // Shella removes/changes by line number. Resolve that line to its current key
  // immediately before mutating so same-variant creations remain independent.
  function patchShella() {
    if (!window.theme || !window.theme.Cart || window.theme.Cart.__cdcTextileV2) return false;
    var controller = window.theme.Cart;
    var original = controller.changeItemByLine.bind(controller);
    controller.changeItemByLine = function (line, quantity) {
      return cart().then(function (before) {
        var selected = before.items[Number(line) - 1];
        if (!selected || !selected.properties || !selected.properties._cdc_creation_id) return original(line, quantity);
        return fetch(cartUrl + '/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selected.key, quantity: Number(quantity) })
        }).then(function (response) { if (!response.ok) throw new Error('Modification refusée.'); return response.json(); })
          .then(function (updated) { controller.setCurrentData(updated); send(publishedState(updated)); return updated; });
      });
    };
    controller.__cdcTextileV2 = true;
    return true;
  }
  if (!patchShella()) {
    var attempts = 0;
    var timer = setInterval(function () { if (patchShella() || ++attempts > 60) clearInterval(timer); }, 250);
  }
  window.addEventListener('focus', function () { void sync(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) void sync(); });
  window.addEventListener('storage', function (event) { if (event.key === 'cartCurrentData') void sync(); });
  document.addEventListener('theme:cart::added', function () { setTimeout(sync, 250); });
  document.addEventListener('theme:cart::removed', function () { setTimeout(sync, 500); });
})();
